// actionTypes.js
export const COLLABORATOR__FETCH_DATA_REQUEST = "COLLABORATOR__FETCH_DATA_REQUEST";
export const COLLABORATOR__FETCH_DATA_SUCCESS = "COLLABORATOR__FETCH_DATA_SUCCESS";
export const COLLABORATOR__FETCH_DATA_FAILURE = "COLLABORATOR__FETCH_DATA_FAILURE";
